export default "__VITE_ASSET__DIJNiAMt__"